import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { get } from "helpers/api_helper"
import { genericName, lineName, sheetStatuses, supplierNames } from "./components/Tabs/Logistics/labels"
import "./components/Tabs/Logistics/logistics.scss"

// The Logistics block of Event details (US 7): the sheet's generic lines with their product and
// supplier, read-only, for a SuperAdmin. They change only in the event's Logistics tab.
export default function EventLogisticsSummary({ eventId }) {
  const [state, setState] = useState({ loading: true })
  useEffect(() => {
    let active = true
    setState({ loading: true })
    get(`/admin/logistics/events/${eventId}/sheet`).then(response => {
      if (!response?.data || !("sheet" in response.data)) throw new Error("Invalid sheet")
      if (active) setState({ sheet: response.data.sheet })
    }).catch(() => { if (active) setState({ error: true }) })
    return () => { active = false }
  }, [eventId])
  const { sheet } = state

  return <section aria-label="Logistics"><h3><i className="bx bx-package mr-1" aria-hidden="true" />Logistics</h3>
    <p className="text-muted small">Read-only · visible to SuperAdmin</p>
    {state.loading && <p role="status">Loading the logistics sheet…</p>}
    {state.error && <p className="text-muted">The logistics sheet could not be loaded.</p>}
    {sheet === null && <p>No logistics sheet (event before launch).</p>}
    {sheet && <>
      <table className="table table-sm logistics-stack mb-2"><tbody>
        {sheet.lines.filter(line => line.generic).map(line => <tr key={line.key}>
          <td><strong>{genericName(line)}</strong></td>
          <td data-label="Product">{lineName(line, sheet.officialBall)}{line.productChosen ? " · chosen" : ""}</td>
          <td data-label="Supplier">{supplierNames[line.supplier] || line.supplier || "—"}{line.supplierChosen ? " · chosen" : ""}</td>
        </tr>)}
      </tbody></table>
      <p className="text-muted small mb-0">
        Sheet: {sheetStatuses[sheet.status]?.label || sheet.status} · Edited from the event's <Link to={`/events/${eventId}/logistics`}>Logistics tab</Link>.
      </p>
    </>}
  </section>
}
